import { type Validation } from './utils';

interface InvoiceFormValues {
  [key: string]: unknown;
  items: unknown[];
}

const validations: Validation<InvoiceFormValues>[] = [
  ({ items }) => {
    if (!items.length) {
      return {
        items: 'Select an item to create invoice',
      };
    }
    return true;
  },
];

const KEYS = [
  'trackingNumber',
  'shipper',
  'shipDate',
  'barcodeItems',
];

export {
  validations,
  KEYS,
};
